import {
	genTestUserSig
} from "./GenerateTestUserSig.js";
import Vue from "vue";
import store from "@/store/index";

import {
	chat,
	$TencentCloudChat,
	$TencentCloudChatEvent,
	$TencentCloudChatType,
	$SKD_STATUS,
	eventInstance
} from "./create";

let config = {
	SDKAppID: 1721000626,
	secretKey: "022f2b1454cc798f47cf27a32a3ec406f5aaa12a1696ece2fd0412ac3ecbe0da"
};

const chatLogin = ({
	userID
})=>{
	let {
		SDKAppID,
		userSig
	} = genTestUserSig({SDKAppID: config.SDKAppID, secretKey: config.secretKey, userID});

	let imLogin = Vue.prototype.$IM_LOGIN;
	// console.log("imLogin====",imLogin);
	// if(!imLogin){
		let promise = chat.login({userID, userSig});

		promise.then(function(imResponse) {
		  // console.log(imResponse.data,"登录成功"); // 登录成功
		  
		  eventInstance.on("TencentCloudChat.EVENT.SDK_READY",()=>{
			$SKD_STATUS.$LOGIN_SUCCESS = true;
			$SKD_STATUS.$SKD_READY = true;
			  eventInstance.emit("im-login",{
			  		unreadCount: getUnreadCount()
			  });
				eventInstance.emit("EVENT.LOGIN_SUCCESS",{
					data: imResponse
				})
				// console.error("====login-success========");
		  });

			eventInstance.on("TencentCloudChat.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED",(data)=>{
				// console.error("init====",data.event,data);
				let {event} = data;
				
				eventInstance.emit("TOTAL_UNREAD_MESSAGE_COUNT_UPDATED",{
			  		unreadCount: event.data || 0
			  });
			})

		  if (imResponse.data.repeatLogin === true) {
		    // 标识账号已登录，本次登录操作为重复登录。
		    console.log(imResponse.data.errorInfo);
		  }
		}).catch(function(imError){
		  console.warn('登录失败login error:', imError); // 登录失败的相关信息
		});
	// }

}

const getUnreadCount = ()=>{

	return chat.getTotalUnreadMessageCount();
}

// 初始化IM实例
const initIMInstance = ()=>{
	let userID = store.state.id;
	// console.log("========");
	if(userID){
		console.log("====已登录");
		chatLogin({userID});
	}
	else{
		// console.log("====未登录");
		eventInstance.on("login-success",()=>{
			// console.log("===重新登录 im");
			let userID = store.state.id;
			chatLogin({userID});
		});
	}
}

// 当用户被踢下线的重新登录
const kickOutIMReLogin = ()=>{
	eventInstance.on("TencentCloudChat.EVENT.KICKED_OUT",()=>{
		// initIMInstance();
	});
}

// IM实例销毁
const	imInstanceDestroy = ()=>{
	if(chat){
		let promise = chat.logout();
		promise.then(function(imResponse) {
			console.log(imResponse.data); // 登出成功
		}).catch(function(imError) {
			console.warn('logout error:', imError);
		});
	}
}

export {
	chat,
	$TencentCloudChat,
	$TencentCloudChatEvent,
	$TencentCloudChatType,
	$SKD_STATUS,
	chatLogin,
	getUnreadCount,
	eventInstance,
	initIMInstance,
	kickOutIMReLogin,
	imInstanceDestroy
}
